<template>
    <CSearch />
</template>

<script>

    import { mapState, mapActions } from "vuex";

    import CSearch from "@/components/CSearch";

    export default {
        name: "Search",
        components: {
            CSearch
        },
        computed: {
            ...mapState([ "enterprise", "industry" ]),
            params() {
                return {
                    enterprise: this.enterprise,
                    industry: this.industry
                }
            }
        },
        methods: {
            ...mapActions(["updateBTableDataAsync", "updateTDataAsync", "updateBDataAsync"])
        },
        mounted() {

            this.updateTDataAsync();
            this.updateBDataAsync();
        },
        watch: {
            params: {
                deep: true,
                immediate: true,
                handler(val) {
                    this.updateBTableDataAsync(val);
                }
            }
        }
    };
</script>